/* eslint-disable react/prop-types */
import React from 'react';
import { _PaymentTable, _PaymentLabel, _PaymentContent, _PaymentWrapper, _FreePrice } from "./styles";
import { _Anchorable } from "../style/CommonStyles";
import RedStrikeThrough from "../core/ui/RedStrikeThrough";
import PaymentGroup from "./PaymentGroup";
import PaymentStatus from "./PaymentStatus";
import useInitialProps from "../../hooks/useInitialProps";
import { formatCurrency } from '@applyboard/ui-utils';
import { currencyObjectSelector } from "../../util/currency";
var Payment = function Payment(_ref) {
  var appPrice = _ref.appPrice,
    applicationFee = _ref.applicationFee,
    applicationFeeTip = _ref.applicationFeeTip,
    info = _ref.info,
    perApplicationCharges = _ref.perApplicationCharges,
    perStudentCharges = _ref.perStudentCharges,
    renderOriginalApplicationFee = _ref.renderOriginalApplicationFee,
    permissions = _ref.permissions;
  var _useInitialProps = useInitialProps(),
    currencies = _useInitialProps.currencies;
  return /*#__PURE__*/React.createElement(_PaymentWrapper, null, /*#__PURE__*/React.createElement(PaymentStatus, {
    info: info,
    appPrice: appPrice,
    permissions: permissions
  }), /*#__PURE__*/React.createElement(_PaymentTable, null, /*#__PURE__*/React.createElement(_PaymentLabel, null, "Application Fee"), /*#__PURE__*/React.createElement(_PaymentContent, null, renderOriginalApplicationFee && /*#__PURE__*/React.createElement(_Anchorable, {
    "data-tip": "Original Application Fee",
    original_price: true
  }, /*#__PURE__*/React.createElement(RedStrikeThrough, null, formatCurrency(applicationFee.original_price, currencyObjectSelector(currencies, applicationFee.currency)))), appPrice > 0 ? /*#__PURE__*/React.createElement(_Anchorable, {
    "data-tip": applicationFeeTip
  }, formatCurrency(appPrice, currencyObjectSelector(currencies, applicationFee.currency))) : /*#__PURE__*/React.createElement(_FreePrice, {
    "data-tip": applicationFeeTip
  }, "Free")), /*#__PURE__*/React.createElement(PaymentGroup, {
    section: "application-fees",
    title: "Additional Application Fee(s)",
    payments: perApplicationCharges
  }), /*#__PURE__*/React.createElement(PaymentGroup, {
    section: "student-fees",
    title: "Additional Student Fee(s)",
    payments: perStudentCharges
  })));
};
export default Payment;